import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from "../../buttons/Button";
import Grid from "../../dataGrid/DataGrid";
import Tabs from "../../TabsWrapper";
import Tab from "../../Tab";
import DropDownList from "../../forms/DropDownList";
import flags from "../../utils/flags";
import withMeta from '../../utils/withMeta';
import { processAfter, isDateType } from '../../utils/helper';
import LoadingPanel from "../../LoadingPanel";
import { useFirstRender } from '../../utils/hooks';
import { showMsg } from "../../utils/logger";
import { processFilter } from '../../dataGrid/gridHelper';

const AKT_DATA = [
  { id: 0, name: 'Doplniť práva' },
  { id: 1, name: 'Zaktualizovať práva' },
  { id: 2, name: 'Obnoviť práva' }
];

let _filter, _sort;
let _page = { skip: 0, take: 50 };
const PravaSkup = (props) => {
  const [state, setState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    selected: [],
    akt: AKT_DATA[0]
  });

  const [schema, setSchema] = useState([]);
  const getSchema = props.meta.getSchema;
  const gridDateColumnsRef = useRef([]);

  const fixedFilter = { filters: [{ field: "Uz.IUz", operator: "eq", value: props.uz.IUz }, { field: "Zrus", operator: "eq", value: false }] };

  useEffect(() => {
    const getGridSchema = async () => {
      const res = await getSchema("IUzSkup", props.db);
      gridDateColumnsRef.current = res.Grid.filter(x => isDateType(x.filter));
      setSchema(res.Grid)
      return res.Grid
    };

    getGridSchema()
  }, [getSchema, props.db])

  // aby useEffect(..., [props.refresh]) nerobil kontrolu _.isEqual(oldSelected, newSelected) pri 1. rendery, 
  // lebo prv sa spusta useEffect az po nom getList(), ktory nastavi oldSelected a newSelected
  const firstRender = useFirstRender();

  const onChange = (filter, sort, page) => {
    _filter = filter ? filter : _filter;
    _sort = sort ? sort : _sort;
    _page = page ? page : _page;
  }

  const getList = async () => {
    try {
      setState(prevState => ({ ...prevState, isLoading: true, data: [], total: 0 }));
      const f = processFilter(_filter, fixedFilter)
      const res = await props.meta.getList("IUzSkup", f, _sort, _page, props.db);

      if (gridDateColumnsRef.current.length > 0) {
        res.Data.Items.map(x => {
          x = processAfter(gridDateColumnsRef.current, x);
          return x;
        })
      }

      setState(prevState => ({ ...prevState, isLoading: false, data: res.Data.Items, total: res.Data.TotalRecords }));
      props.getListSuccess(res);
    }
    catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false, data: [], total: 0 }));
      props.getListFailure(error);
    }
  }

  const handleSelect = (selected) => {
    setState(prevState => ({ ...prevState, selected }));
  }

  // componentDidUpdate
  useEffect(() => {
    if (!firstRender) {
      onNext();
    }
    // eslint-disable-next-line
  }, [props.refresh]);

  const onNext = async () => {
    try {
      setState(prevState => ({ ...prevState, isLoading: true }));
      const data = state.selected.map(x => ({ iAkt: state.akt.id, iSkup: x.Skup.ISkup, iUz: props.uz.IUz }))
      await props.meta.setPravaSkup(data, props.db);
      setState(prevState => ({ ...prevState, isLoading: false }));
      props.showMsg("Práva úspešne priradené");
      props.onSubmit();
    }
    catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false }));
      props.showMsg(error.message, 'error');
    }
  }

  const handleChange = (name, value) => {
    setState(prevState => ({ ...prevState, [name]: value }));
  }


  return (
    <>
      <LoadingPanel isLoading={state.isLoading} />
      <Tabs localTabsType>
        <Tab title="">
          {schema.length > 0 && <Grid
            toolbarActions={<div className="akc-prava">
              <DropDownList
                name="akt"
                data={AKT_DATA}
                textField="name"
                onChange={handleChange}
                value={state.akt}
              />
            </div>}
            primaryField="IUzSkup"
            isLoading={state.isLoading}
            data={state.data}
            total={state.total}
            schema={schema || []}
            onChange={onChange}
            onGetList={getList}
            onGet={() => { }}
            selected={state.selected}
            onSelect={handleSelect}
            hidden={flags.ADD | flags.CANCEL | flags.COPY | flags.DELETE | flags.DETAIL}
            multiple
            fixedFilter={fixedFilter}
            withMeta
            page={_page}
            sort={_sort}
            updateSort={() => { }}
            userFilterExtended={[]}
          />}
        </Tab>
      </Tabs>
      <Button
        buttonWrapperClassName={"next-button"}
        label={"Nastaviť práva"}
        onClick={onNext}
        disabled={state.selected.length === 0}
        primary
      />
    </>
  );

}

PravaSkup.propTypes = {
  refresh: PropTypes.number,
  uz: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = dispatch => ({
  getListSuccess: res => dispatch({ type: 'GET_LIST_SUCCESS', res }),
  getListFailure: error => dispatch({ type: 'GET_LIST_FAILURE', error }),
  createFailure: error => dispatch({ type: 'CREATE_FAILURE', error }),
  showMsg: (msg, msgType = 'ok') => dispatch(showMsg(msg, msgType))
})


export default withMeta(connect(mapStateToProps, mapDispatchToProps)(PravaSkup));
